import React from 'react';
import ClassesListView from '../components/ClassesListView';

const WorkingClasses = () => {
  return (
    <ClassesListView 
      visaType="Working" 
      title="Working Visa Classes" 
    />
  );
};

export default WorkingClasses;
